// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-main-login,
.app-main {
  position: absolute;
  border: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  min-width: 300px;
  padding: 0;
}
.ant-menu-dark {
  background: #130e52;
}
.ant-btn {
  padding: 6px 12px;
  height: 36px;
  border-radius: 2px;
}
.ant-btn-primary {
  border-radius: 2px;
  background-color: #531dab;
  color: #ffffff;
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
}
.ant-btn-primary:hover {
  background-color: #8847ff !important;
}
.ant-btn-default {
  background-color: #ffffff;
  border: 1px solid #661eff;
  color: #661eff;
  font-family: 'Nunito', sans-serif;
  font-weight: 700;
  font-size: 14px;
}
.ant-btn-default:hover:not([disabled]) {
  border: 1px solid #efdbff !important;
  color: #661eff !important;
  background-color: #efdbff !important;
}
.ant-input-group-addon .ant-btn-default {
  border: 1px solid #d9d9d9;
}
.ant-layout-sider-children .ant-menu-item-selected {
  background-color: #efdbff !important;
}
.ant-layout-sider-children .ant-menu-item-selected svg path {
  fill: #722ed1 !important;
}
a {
  color: #661eff;
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
}
a:hover {
  color: #ec47ec;
}
.ant-pagination-item-active {
  border: 1px solid #661eff !important;
}
.ant-pagination-item-active a {
  color: #661eff !important;
}
.ant-menu-horizontal.nav-procedures {
  color: #661eff !important;
}
html {
  scroll-behavior: smooth;
}
body ::-webkit-scrollbar {
  background: transparent;
  width: 6px;
  height: 6px;
}
body ::-webkit-scrollbar-thumb {
  background: lightgray;
  width: 6px;
  border-radius: 6px;
  height: 6px;
}
.page-context-header {
  display: flex;
  overflow: hidden;
}
.app-header {
  display: flex;
  height: 50px;
  align-items: center;
  padding: 0px 16px;
}
.app-header .ant-breadcrumb {
  margin-bottom: 0;
}
.runviewLayout-header {
  position: sticky;
  z-index: 1;
  background: #f4f4f6;
  top: 42px;
}
.parse-feedback-modal {
  width: 70% !important;
}
.borderedTextBtn {
  border-radius: 2px;
  height: 32px;
  border-color: #d1d1d1;
  display: flex;
  color: #595973;
  justify-content: center;
  align-items: center;
  font-weight: 400;
}
.textActionBtn {
  border-radius: 2px;
  height: 32px;
  padding: 5px 0;
}
.textActionBtn svg path {
  fill: #595973;
}
`, "",{"version":3,"sources":["webpack://./src/App.less"],"names":[],"mappings":"AAGA;;EAEE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AAFF;AAKA;EACE,mBAAA;AAHF;AAOA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;AALF;AAQA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,iCAAA;EACA,eAAA;AANF;AAQE;EACE,oCAAA;AANJ;AAUA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AARF;AAUE;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AARJ;AAYA;EAEI,yBAAA;AAXJ;AAeA;EAGI,oCAAA;AAfJ;AAYA;EAOQ,wBAAA;AAhBR;AAsBA;EACE,cAAA;EACA,iCAAA;EACA,eAAA;AApBF;AAsBE;EACE,cAAA;AApBJ;AAwBA;EACE,oCAAA;AAtBF;AAqBA;EAGI,yBAAA;AArBJ;AA0BE;EACE,yBAAA;AAxBJ;AA4BA;EACE,uBAAA;AA1BF;AA6BA;EAEI,uBAAA;EACA,UAAA;EACA,WAAA;AA5BJ;AAwBA;EAOI,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AA5BJ;AAgCA;EACE,aAAA;EACA,gBAAA;AA9BF;AAiCA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AA/BF;AA2BA;EAMI,gBAAA;AA9BJ;AAkCA;EACE,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,SAAA;AAhCF;AAmCA;EACE,qBAAA;AAjCF;AAoCA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAlCF;AAqCA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;AAnCF;AAgCA;EAOM,aAAA;AApCN","sourcesContent":["@import '@css/variables.less';\n\n// the main app view\n.app-main-login,\n.app-main {\n  position: absolute;\n  border: none;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  min-width: 300px;\n  padding: 0;\n}\n\n.ant-menu-dark {\n  background: #130e52;\n}\n\n// Custom design changes recommended by Y&N\n.ant-btn {\n  padding: 6px 12px;\n  height: 36px;\n  border-radius: 2px;\n}\n\n.ant-btn-primary {\n  border-radius: 2px;\n  background-color: @color-primary-action;\n  color: @white;\n  font-family: @baseFont;\n  font-size: @fontSizeRegular;\n\n  &:hover {\n    background-color: @color-primary-action-hover !important;\n  }\n}\n\n.ant-btn-default {\n  background-color: @white;\n  border: 1px solid @color-secondary-action;\n  color: @color-secondary-action;\n  font-family: @baseFont;\n  font-weight: @fontWeightBold;\n  font-size: @fontSizeRegular;\n\n  &:hover:not([disabled]) {\n    border: 1px solid @color-secondary-action-hover !important;\n    color: @color-secondary-action !important;\n    background-color: @color-secondary-action-hover !important;\n  }\n}\n\n.ant-input-group-addon {\n  .ant-btn-default {\n    border: 1px solid @border-inner-color;\n  }\n}\n\n.ant-layout-sider-children {\n  .ant-menu-item-selected {\n    // border-radius: 50%;\n    background-color: @color-secondary-action-hover !important;\n\n    svg {\n      path {\n        fill: #722ed1 !important;\n      }\n    }\n  }\n}\n\na {\n  color: @color-secondary-action;\n  font-family: @baseFont;\n  font-size: @fontSizeRegular;\n\n  &:hover {\n    color: @color-tertiary-action-hover;\n  }\n}\n\n.ant-pagination-item-active {\n  border: 1px solid @color-secondary-action !important;\n  a {\n    color: @color-secondary-action !important;\n  }\n}\n\n.ant-menu-horizontal {\n  &.nav-procedures {\n    color: @color-secondary-action !important;\n  }\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  ::-webkit-scrollbar {\n    background: transparent;\n    width: 6px;\n    height: 6px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: lightgray;\n    width: 6px;\n    border-radius: 6px;\n    height: 6px;\n  }\n}\n\n.page-context-header {\n  display: flex;\n  overflow: hidden;\n}\n\n.app-header {\n  display: flex;\n  height: 50px;\n  align-items: center;\n  padding: 0px 16px;\n  .ant-breadcrumb {\n    margin-bottom: 0;\n  }\n}\n\n.runviewLayout-header {\n  position: sticky;\n  z-index: 1;\n  background: #f4f4f6;\n  top: 42px;\n}\n\n.parse-feedback-modal {\n  width: 70% !important;\n}\n\n.borderedTextBtn {\n  border-radius: 2px;\n  height: 32px;\n  border-color: #d1d1d1;\n  display: flex;\n  color: #595973;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n}\n\n.textActionBtn {\n  border-radius: 2px;\n  height: 32px;\n  padding: 5px 0;\n\n  svg {\n    path {\n      fill: #595973;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
